// Imports
import React, { useState, useEffect, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import styled from "styled-components";
import debounce from "lodash/debounce";
import GlobalStyle from './GlobalStyle';

// Styles and components
const CheckboxWrapper = styled.div`
  margin-top: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;
const FormContainer = styled.div`
  background-color: #fff9c4; /* giallo chiaro */
  max-width: 600px;
  margin: auto;
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  position: relative;
`;
const Input = styled.input`
  width: 100%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 4px;
`;
const Button = styled.button`
  width: 100%;
  padding: 10px;
  background: #28a745;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 10px;
  &:hover {
    background: #218838;
  }
`;
const ListContainer = styled.ul`
  margin-top: -5px; /* poco margine se serve */
  border: 1px solid #ccc;
  padding: 0;
  list-style: none;
  max-height: 200px;
  overflow-y: auto;
  background: white;
  width: 100%;
  border-radius: 4px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
`;
const ListItem = styled.li`
  padding: 10px;
  cursor: pointer;
  background: #f9f9f9;
  border-bottom: 1px solid #ddd;
  &:hover {
    background: #e0e0e0;
  }
`;
const Select = styled.select`
  width: 100%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 4px;
`;
const QuantityContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;
const QuantityInput = styled(Input)`
  width: 70%;
`;
const UnitSelect = styled(Select)`
  width: 30%;
  margin-left: 10px;
`;
const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;


// Main function
const AddProduct = ({ existingOrderId = null, initialFormattedOrderId = null, returnToEditProducts = false }) => {
 const navigate = useNavigate();
 const [formattedOrderId, setFormattedOrderId] = useState(initialFormattedOrderId || "");
 const [orderId, setOrderId] = useState("");
 const [productName, setProductName] = useState("");
 const [code, setCode] = useState("");
 const [quantity, setQuantity] = useState("");
 const [filteredProducts, setFilteredProducts] = useState([]);
 const [filteredCustomers, setFilteredCustomers] = useState([]);
 const [loading, setLoading] = useState(false);
 const [setNoResults] = useState(false);
 const [showProductList, setShowProductList] = useState(false);
 const [showCustomerList, setShowCustomerList] = useState(false);
 const [unit, setUnit] = useState("");
 const [unitOptions, setUnitOptions] = useState([]);
 const [customer, setCustomer] = useState("");
 const [orderDate, setOrderDate] = useState("");
 const [isFirstProduct, setIsFirstProduct] = useState(!existingOrderId);
 const dropdownRef = useRef(null);
 const [purchasePrice, setPurchasePrice] = useState(null);
 const [salePrices, setSalePrices] = useState([]);
 const [products, setProducts] = useState([]);
 const [selectedSalePrice, setSelectedSalePrice] = useState("");
 const [alternativeQuantity, setAlternativeQuantity] = useState("");
 const [productsToEdit, setProductsToEdit] = useState([]);
 const [currentProductIndex, setCurrentProductIndex] = useState(0);
 const [ritiroInsede, setRitiroInsede] = useState(false);
 const [manualSalePrice, setManualSalePrice] = useState("");
 const [isManualPrice, setIsManualPrice] = useState(false);
 const [manualPriceValue, setManualPriceValue] = useState("");
 const [lotto, setLotto] = useState('');
 const effectiveSalePrice = selectedSalePrice === "manuale" ? manualSalePrice : selectedSalePrice;
 const partialPrice = quantity && effectiveSalePrice ? (parseFloat(quantity) * parseFloat(effectiveSalePrice.replace(/[^\d.]/g, ''))).toFixed(2) : "0.00";
 const [IdForSearch, setIdForSearch] = useState("");
 const [iva, setIva] = useState("");
 const [codCliente, setCodCliente] = useState("");
const [drivers, setDrivers] = useState([]);
const [selectedDriver, setSelectedDriver] = useState("");

 // ############################ AGGIUNTA
 // Funzione per generare un orderId unico con # come prefisso
  const generateUniqueOrderId = async (customer, onlyDate) => {
    const baseCustomer = customer.trim();
    const baseId = `${baseCustomer} - ${onlyDate}`;
    let attempt = 0;
    let finalId = baseId;

    while (true) {
      try {
        await axios.get(`/api/orders/${encodeURIComponent(finalId)}`);
        // se esiste già
        attempt++;
        finalId = `#${attempt + 1} ${baseCustomer} - ${onlyDate}`;
      } catch (err) {
        if (err.response && err.response.status === 404) {
          break;
        } else if (!err.response) {
          console.error("Errore nella verifica ordine:", err);
          throw err;
        } else {
          throw err;
        }
      }
    }
    return finalId;
  };
  // ###########################################################################



// Use effect per generare nome ordine corretto
useEffect(() => { if (existingOrderId && !formattedOrderId) { setFormattedOrderId(existingOrderId); } }, [existingOrderId, formattedOrderId]);

  const handleAddProduct = async () => {
    if (!productName || !code) {
      return alert("Please enter all product details.");
    }
    if (isFirstProduct && (!customer || !orderDate)) {
      return alert("Please enter customer and order date.");
    }
    const onlyDate = orderDate.includes("T") ? orderDate.split("T")[0] : orderDate;

    let generatedId = `${customer.trim()} - ${onlyDate}`;
    if (isFirstProduct) {
      try {
        generatedId = await generateUniqueOrderId(customer, onlyDate);
        await axios.post("/api/NewOrder", {
          orderId: generatedId,
          customer,
          orderDate,
          ritiroInsede: ritiroInsede ? "si" : "no",
          codCliente,
	  autista: selectedDriver
        });
        setFormattedOrderId(generatedId);
        setOrderId(generatedId);
        setIsFirstProduct(false);
      } catch (error) {
        console.error("Error creating order:", error);
        return;
      }
    }

    const orderToUse = formattedOrderId || generatedId;
    try {
      await axios.post(`/api/orders/${encodeURIComponent(orderToUse)}/products`, {
        productName,
        quantity: parseFloat(quantity),
        unit,
        alternativeQuantity,
        customer,
        orderDate,
        code,
        purchasePrice,
        selectedSalePrice: selectedSalePrice === "manuale" ? `${manualSalePrice} €` : selectedSalePrice,
        partialPrice,
        lotto,
        iva
      });

      if (productsToEdit.length > 0 && currentProductIndex < productsToEdit.length - 1) {
        setCurrentProductIndex(currentProductIndex + 1);
      } else {
        setProductsToEdit([]);
        setCurrentProductIndex(0);
        setProductName("");
        setQuantity("");
        setUnit("");
        setCode("");
        setPurchasePrice(null);
        setSelectedSalePrice("");
        setManualSalePrice("");
        setAlternativeQuantity("");
        setFilteredProducts([]);
        setShowProductList(false);
        setLotto("");
      }
    } catch (error) {
      console.error("Error adding product:", error);
    }
  };

useEffect(() => {
  axios.get("/api/autisti")
    .then(res => setDrivers(res.data))
    .catch(err => console.error("Errore caricamento autisti:", err));
}, []);

 // Prezzo acquisto
 const fetchPurchasePrice = async (code) => {
  if (!code) return;
   const cleanedCode = code.replace(/\s+/g, '');
   try {
    const response = await axios.get(`/api/prezzoacq/${encodeURIComponent(cleanedCode)}`);
    setPurchasePrice(response.data.price ?? "N/A");
   } catch {
    setPurchasePrice("Error");
   }
 };

 // Prezzi vendita
 const fetchSalePrices = async (code, codClienteParam = "") => {
  if (!code) return;
  const cleanedCode = code.replace(/\s+/g, '');
  const clientCode = (codClienteParam || "").trim();
  try {
   const response = await axios.get(`/api/prezzoven/${encodeURIComponent(cleanedCode)}${clientCode ? `?codCliente=${clientCode}` : ""}`);
    const data = Array.isArray(response.data) ? response.data : [response.data];
    const sortedPrices = data.map(p => `${parseFloat(p.PREZZO).toFixed(2)} €`);
    setSalePrices(sortedPrices);
  } catch (error) {
    console.error("Errore nel caricamento dei prezzi di vendita:", error);
  }
 };

 // Debounced clienti
 const fetchFilteredCustomers = useCallback(
  debounce(async (filter) => {
   if (!filter) {
    setFilteredCustomers([]);
    setShowCustomerList(false);
   return;
   }
    setLoading(true);
    try {
     const { data } = await axios.get(`/api/clienti?filter=${encodeURIComponent(filter)}`);
      setFilteredCustomers(data);
      setShowCustomerList(Boolean(data.length));} 
    catch (error) {
     console.error(error);} 
    finally {setLoading(false);} 
  }, 500),
  [IdForSearch]
 );

 // Popola subito customer per filtrare prodotti già acquistati
 const generateIdForSearch = (cust, date) => {
   if (!cust || !date) return "";
   const normalizedCustomer = cust.trim().replace(/\s+/g, " ");
   return `${normalizedCustomer} - ${date}`;
 };

 // useEffect per prodotti già acquistati
 useEffect(() => {
   const newId = generateIdForSearch(customer, orderDate);
   setIdForSearch(newId);
 }, [customer, orderDate]);

 // Debounce Prodotti
 const fetchFilteredProducts = useCallback(
  debounce(async (filter, idSearch) => {
   if (!filter) {
    setFilteredProducts([]);
    setShowProductList(false);
    return;
   }
   setLoading(true);
   try {
    const { data } = await axios.get(`/api/products?filter=${filter}&IdForSearch=${idSearch}`);
    if (data.length) {
      const sorted = [...data].sort((a, b) => {
      if (a.source === 'internal' && b.source !== 'internal') return -1;
      if (a.source !== 'internal' && b.source === 'internal') return 1;
      return 0;
     });
     const combined = sorted.map(p => {
      const code = (p.code || p.productCode || "").trim();
      const name = (p.productName || "").trim();
      const ARUNMIS1 = (p.ARUNMIS1 || "").trim();
      const ARUNMIS2 = (p.ARUNMIS2 || "").trim();
      let dateInfo = "";
       if (p.source === "internal" && p.date) {
       dateInfo = ` (${p.date})`;
       }
      return {
       ...p,
       ARCODART: code,
       ARDESART: name,
       ARUNMIS1: ARUNMIS1,
       ARUNMIS2: ARUNMIS2,
       ARCODIVA: p.iva || p.ARCODIVA || "",
       combinedDescription: `${code} ${name} ${dateInfo}`,
       cleanDescription: `${code} ${name}`
      };
     });
      setFilteredProducts(combined);
      const firstInternal = combined.find(p => p.source === 'internal');
       if (firstInternal) {
        fetchPurchasePrice(firstInternal.code || firstInternal.productCode);
        await fetchSalePrices(firstInternal.code || firstInternal.productCode);
       }
       setShowProductList(true);
       setNoResults(false);
    } 
    else {setNoResults(true); setShowProductList(false);}
   } catch (error) {console.error(error);} 
   finally {
    setLoading(false);
   }
  }, 500),
  []
);


 useEffect(() => {
 // Logica per ordine già esistente
 if (existingOrderId) {
   axios.get(`/api/orders/${existingOrderId}`)
   .then((res) => {
     const order = res.data;
     console.log("Risposta ordine esistente:", order);
     if (order.products && order.products.length > 0) {
      const productData = order.products[0];
      const parsedProducts = productData.products ? (typeof productData.products === 'string' ? JSON.parse(productData.products) : productData.products) : [];
       setOrderId(order.orderId);
       setCustomer(parsedProducts[0]?.customer?.trim() || "");
       setOrderDate(order.orderDate);
       setProducts(parsedProducts);
       setSelectedSalePrice(order.selectedSalePrice);
       setSelectedSalePrice( order.selectedSalePrice != null ? String(order.selectedSalePrice) : "" );
       setProductsToEdit(parsedProducts);
       setIsFirstProduct(false);
       setCurrentProductIndex(0);
     } else {
       console.error("Ordine non trovato o prodotti assenti.");
    }
   })
   .catch((err) =>
     console.error("Errore caricamento ordine esistente:", err)
   );

 // intercetta click fuori da dropdown
  const handleClickOutside = e => {
   if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
    setShowProductList(false);
    setShowCustomerList(false);
   }
  };
     document.addEventListener("mousedown", handleClickOutside);
     return () => {document.removeEventListener("mousedown", handleClickOutside);};}
 }, [existingOrderId]);


 // Get codice cliente
const fetchCodCliente = async (nomeCliente) => {
  if (!nomeCliente) return;
  const normalized = nomeCliente.trim().replace(/\s+/g, ' ');
  try {
    const response = await axios.get(`/api/cliente-codice?nome=${encodeURIComponent(normalized)}`);
    setCodCliente(response.data.codice || "");
  } catch (error) {
    console.error("Errore nel recupero del codice cliente:", error);
    setCodCliente("");
  }
};

 // termina e salva ordine
const handleFinish = async () => {
  try {
    alert("✅ Order completed.");
    if (returnToEditProducts && orderId) {
      navigate("/ordersedit", { state: { highlightOrderId: orderId } });
    } else {
      navigate("/OrderMgmt", { state: { reload: true } });
    }
  } catch (error) {
    console.error("Errore nel completare l'ordine:", error);
    alert("❌ Errore nel completare l'ordine");
  }
};


// Return
return (
 <>
 <GlobalStyle />
  <FormContainer ref={dropdownRef}>
   <h2>Aggiungi/modifica prodotto a ordine {orderId}</h2>
   {isFirstProduct && (
    <>
     <label>Customer:</label>
      <Input value={customer} onChange={e => { setCustomer(e.target.value); fetchFilteredCustomers(e.target.value); }} onFocus={() => setShowCustomerList(true)} placeholder="Search customer" />
      {showCustomerList && (
       <ListContainer>
        {filteredCustomers.map(c => ( <ListItem key={c.ANDCODICE} onClick={() => { setCustomer(c.ANDESCRI); setShowCustomerList(false); fetchCodCliente(c.ANDESCRI.trim().replace(/\s+/g, ' '));}}
         > {c.ANDESCRI}
         </ListItem>
        ))}
       </ListContainer>
      )}
     <label>Data consegna:</label>
      <Input type="date" value={orderDate} onChange={e => setOrderDate(e.target.value)} />

<CheckboxWrapper style={{ display: 'flex', alignItems: 'center', gap: '2rem' }}>
  <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
    <input
      type="checkbox"
      checked={ritiroInsede}
      onChange={e => setRitiroInsede(e.target.checked)}
    /> Ritiro in sede
  </label>

  <div style={{ display: 'flex', flexDirection: 'column' }}>
    <label style={{ fontSize: '0.9rem', marginBottom: '4px' }}>Autista (opzionale):</label>
    <Select
      value={selectedDriver}
      onChange={e => setSelectedDriver(e.target.value)}
      style={{ minWidth: '180px' }}
    >
      <option value="">Nessuno</option>
      {drivers.map(driver => (
        <option key={driver.nome} value={driver.nome}>
          {driver.nome} - {driver.veicolo}
        </option>
      ))}
    </Select>
  </div>
</CheckboxWrapper>

    </>
   )}

     <label>Product Name:</label>
      <Input value={productName} onChange={e => { setProductName(e.target.value); fetchFilteredProducts(e.target.value, IdForSearch); }}
       onFocus={() => {
        if (productName.trim().length > 1) setShowProductList(true);
       }}
      />
      {showProductList && (
       <ListContainer>
        {filteredProducts.map(p => (
         <ListItem
          key={p.ARCODART}
           onClick={() => {
            setCode(p.ARCODART);
            setProductName(p.cleanDescription);
            setUnitOptions([p.ARUNMIS1, p.ARUNMIS2].filter(Boolean));
	    setUnit(p.ARUNMIS1 || p.ARUNMIS2 || "");
	    setIva(p.ARCODIVA || "");
            setShowProductList(false);
            fetchPurchasePrice(p.ARCODART);
            fetchSalePrices(p.ARCODART, codCliente);
           }}
          style={{
           fontWeight: p.source === "internal" ? "bold" : "normal",
           backgroundColor: p.source === "internal" ? "#e6f7ff" : "transparent",
           padding: "6px 10px",
           cursor: "pointer"
          }}
          >
          {p.combinedDescription}
         </ListItem>
        ))}
       </ListContainer>
      )}

     <label>Quantità sistema:</label>
      <QuantityContainer>
      <QuantityInput
       type="text"
       inputMode="decimal"
       value={quantity}
       onChange={e => {
        let value = e.target.value.replace(/[^\d.,]/g, '');
        value = value.replace(',', '.');
        // Deve rispettare il tipo DECIMAL(10,5) atteso da Zucchetti (TMP_IMPORT_APP.QTA):
        // massimo 5 cifre intere e 5 decimali, separatore punto.
        if (/^\d{0,5}(\.\d{0,5})?$/.test(value)) setQuantity(value);
       }}
      />
       <UnitSelect value={unit} onChange={e => setUnit(e.target.value)}>
        {unitOptions.map((opt, i) => <option key={i} value={opt}>{opt}</option>)}
       </UnitSelect>
      </QuantityContainer>

     <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}> Lotto:
      <input
       type="text"
       value={lotto}
       onChange={e => {
        const val = e.target.value.toUpperCase();
        if (val.length <= 6) setLotto(val);
       }}
       maxLength={8} style={{ width: '100px', padding: '4px 8px', borderRadius: '4px', border: '1px solid #ccc' }      } /> 
     </label>

    <div style={{ display: 'grid', gridTemplateColumns: '150px 1fr', gap: 10, alignItems: 'center' }}>
     <label>Quantità alternativa:</label>
      <Input value={alternativeQuantity} onChange={e => setAlternativeQuantity(e.target.value)} placeholder="Es: 2 pacchi" />

     <label>Prezzo acquisto:</label>
      <Input value={purchasePrice ?? ''} readOnly />

     <label>Prezzo vendita:</label>
      <Select value={selectedSalePrice} onChange={e => {
       const val = e.target.value;
       setSelectedSalePrice(val);
       if (val !== "manuale") setManualSalePrice("");
       }}>
       <option value="">Seleziona un prezzo</option>
       {salePrices.map((sp, i) => <option key={i} value={sp}>{sp}</option>)}
       <option value="manuale">Inserisci manualmente</option>
      </Select>
     {selectedSalePrice === "manuale" && (
      <div style={{ gridColumn: "1 / span 2" }}>
       <label>Prezzo manuale (€):</label>
        <Input
         type="text"
         value={manualSalePrice ? manualSalePrice.toString().replace('.', ',') : ""}
         onChange={e => {
          let value = e.target.value.replace(/[^\d.,]/g, '');
          value = value.replace(',', '.');
          if (/^\d*\.?\d*$/.test(value)) {setManualSalePrice(value);}
         }}
          onBlur={() => {
           if (manualSalePrice) {const floatVal = parseFloat(manualSalePrice);
           if (!isNaN(floatVal)) {setManualSalePrice(floatVal.toFixed(2));}
           }
          }}
          placeholder="Es: 12,50 €"
         />
      </div>
     )}
     <label>Totale parziale (€):</label>
     <Input value={`${partialPrice} €`} readOnly />
   </div>
   <Button onClick={handleAddProduct}>Aggiungi prodotto</Button>
   <Button onClick={() => { handleAddProduct(); handleFinish(); }}>Aggiungi prodotto e termina ordine</Button>
 </FormContainer>
</>
);
};

export default AddProduct;
